import { useState, useEffect, useRef } from "react";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import { useNavigate } from "react-router-dom";
import "../providers/InstallersDocuments.css";
import TablaMRT from "../../features/table/RTable";
import Popper from "@mui/material/Popper";
import { formatEmpresa, highlightText } from "../../utils/functionsFormat";
import {
  headCellLeftAlign,
  headCellCenterAlign,
} from "../../utils/columnStyles";
import { customStringFilter } from "../../features/table/filterFunctions";
import { ClickAwayListener } from "@mui/material";

const Clients = ({ clients }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState({ top: 0, left: 0 });

  const editarCliente = async (id) => {
    navigate(`/proyectos/cliente/editar/${id}`);
  };

  useEffect(() => {
    const fetchData = () => {
      const sortedData = clients.sort((a, b) => {
        const nombreA = (a.nombre || "").toLowerCase();
        const nombreB = (b.nombre || "").toLowerCase();
        return nombreA.localeCompare(nombreB);
      });

      setData(sortedData);
    };

    fetchData();
  }, [clients]);

  const rowIconRef = useRef([]);

  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const columns = [
    {
      accessorKey: "razonSocial",
      header: "Nombre",
      filterFn: customStringFilter,
      width: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre = row.original.razonSocial || "Sin nombre";
        const formateado = formatEmpresa(nombre);
        const filter = table?.getState().globalFilter;
        return highlightText(formateado, filter);
      },
    },
    {
      accessorKey: "alias",
      header: "Nombre corto",
      width: 130,
      filterFn: customStringFilter,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
      Cell: ({ row, table }) => {
        const nombre = row.original.alias || "Sin nombre corto";
        const formateado = formatEmpresa(nombre);
        const filter = table?.getState().globalFilter;
        return highlightText(formateado, filter);
      },
    },
    {
      id: "sub-menu",
      header: " ",
      width: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={() => toggleMenuOptions(row.index)}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>

            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 999 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    background: "white",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  }}
                >
                  <p
                    onClick={() => editarCliente(data[row.index]?.id)}
                    style={{ cursor: "pointer", margin: 0 }}
                  >
                    <img src={Editar} alt="" style={{ marginRight: "8px" }} />
                    Editar cliente
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const options = {
    enableColumnFilters: false,
    enableSorting: true,
    enablePagination: true,
  };

  return (
    <div
      className="clients-container"
      style={{ display: "flex", height: "100%" }}
    >
      <div
        className="clients-content"
        style={{ flex: 1, padding: "10px", width: "80%" }}
      >
        <div
          className="clients-header"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "16px",
          }}
        >
          <h2 style={{ margin: 0 }}>Clientes</h2>
        </div>
        <div className="clients-tableWrap">
          <TablaMRT columns={columns} data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default Clients;
